 const center =[52.125824, -106.659918];  
export default center;